import { useEffect, useState } from "react";

import { fetchPdfSignedUrl } from "src/utils/pdfSignedUrl";

export default function usePdfSignedUrl(resourceType, resourceId, options = {}) {
  const { enabled = true, pathSuffix = null, extraQueryParams = {} } = options;
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;

    if (!enabled || !resourceType || !resourceId) {
      setPdfUrl(null);
      setLoading(false);
      return () => {
        active = false;
      };
    }

    setLoading(true);

    fetchPdfSignedUrl({
      resourceType,
      resourceId,
      pathSuffix,
      extraQueryParams,
    })
      .then((signedUrl) => {
        if (active) {
          setPdfUrl(signedUrl);
        }
      })
      .catch(() => {
        if (active) {
          setPdfUrl(null);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [enabled, resourceType, resourceId, pathSuffix, JSON.stringify(extraQueryParams)]);

  return { pdfUrl, loading };
}
